<mon-panel
        [faIcon]="faIcon"
        [header]="header"
        [subHeader]="subHeader">
    <div slot="mon-panel-body">
         <table-container [collection]="pages" [progress]="promise" class="block px-3">
            <table class="table table-hover table-fixed">
                <thead>
                <tr>
                    <th class="col-sm-6 col-md-3 col-lg-1"></th>
                    <th class="col-sm-20 col-md-26 col-lg-29" translate>Issue</th>
                    <th class="col-sm-6 col-md-5 col-lg-4">&nbsp;</th>
                    <th class="col-sm-8 col-md-7 col-lg-6 text-right" translate>Compliance</th>
                    <th class="col-sm-8 col-md-7 col-lg-6 text-right" translate>Pages</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let seo of pages; trackBy: trackByIndex">
                    <td class="text-v-middle" [attr.aria-label]="'Icon' | translate">
                        <mon-table-policy-type
                                [tooltip]="category | translate"
                                class="inline-block"
                                [color]="seo.ignored ? 'grey' : theme"
                                [passed]="!seo.pages_count && !seo.ignored"
                                [target]="target">
                        </mon-table-policy-type>
                    </td>
                    <td class="text-v-middle">
                        <button (click)="pagesList(seo)"
                                class="btn btn-border-radius btn-link btn-no-opacity pr-1"
                                [disabled]="seo.ignored || seo.pages_count <= 0"
                                [ngClass]="{'text-grey': seo.ignored || seo.pages_count <= 0}"
                                [attr.aria-label]="'Show pages with this SEO issue' | translate"
                                type="button">
                            {{ seo.name | translateSeoIssue }}
                        </button>
                        <span ngbTooltip="{{getHelpMessage(seo)}}"
                              *ngIf="canShowHelpMessage(seo)"
                              class="my-1 py-1 fas fa-question-circle">
                        </span>
                    </td>
                    <td class="text-right text-v-middle">
                        <button class="btn btn-border-radius btn-link"
                                *ngIf="seo.ignored"
                                type="button"
                                (click)="unignoreCheckpoint(seo)"
                                [attr.aria-label]="'Unignore this SEO issue' | translate"
                                [monEventTrigger]="'actionTrigger'"
                                [monEventParams]="{action:'seo-unignore'}"
                                translate>
                            Unignore
                        </button>
                        <button class="btn btn-border-radius btn-link"
                                *ngIf="!seo.ignored"
                                type="button"
                                (click)="ignoreCheckpoint(seo)"
                                [attr.aria-label]="'Ignore this SEO issue' | translate"
                                [monEventTrigger]="'actionTrigger'"
                                [monEventParams]="{action:'seo-ignore'}"
                                translate>
                            Ignore
                        </button>
                    </td>
                    <td class="text-v-middle text-right">
                        <table-compliance *ngIf="!seo.ignored"
                                          [indexNumber]="0"
                                          [data]="[pageCount - seo.pages_count, seo.pages_count]"
                                          [labels]="['', '']">
                        </table-compliance>
                    </td>
                    <td class="text-v-middle text-right">
                        <pages-button (callback)="pagesList(seo)"
                                      *ngIf="seo.pages_count > 0"
                                      [monAriaLabel]="'Show pages with this SEO issue' | translate"
                                      [ngModel]="seo.pages_count">
                        </pages-button>
                        <span *ngIf="seo.pages_count == 0 && !seo.ignored" class="text-success" translate>No issues found</span>
                        <span *ngIf="seo.ignored" class="text-grey" translate>Ignored issue</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </table-container>
    </div>
</mon-panel>
